<template>
  <div class="linkContainer">
    <div v-for="tournamentVisit in tournamentVisits"
       :key="tournamentVisit.id"
       :tournamentVisit="tournamentVisit" class="divLink">
       <router-link :to="/tournaments/ + tournamentVisit.id" class="link"><font-awesome-icon icon="trophy"  class="floatLeft"/> {{tournamentVisit.name}}</router-link> 
    </div>

    <div v-for="clubVisit in clubVisits"
       :key="clubVisit.id"
       :clubVisit="clubVisit" class="divLink">
       <router-link :to="/clubs/ + clubVisit.id" class="link"><font-awesome-icon icon="university"  class="floatLeft"/> {{clubVisit.name}}</router-link> 
    </div>

    <div v-for="personVisit in personVisits"
       :key="personVisit.id"
       :personVisit="personVisit" class="divLink">
       <router-link :to="/persons/ + personVisit.id" class="link"><font-awesome-icon icon="user"  class="floatLeft"/> {{personVisit.name}}</router-link> 
    </div>
  </div>
</template>

<script>


export default {
  name: 'RecentlyVisited',
  data: function () {
    return {
      tournamentVisits: [],
      personVisits: [],
      clubVisits: [],
    }
  },
  beforeMount() {
    var visited = this.$CA_Storage.getVisits();
    console.log("visited: " + JSON.stringify(visited));
    var tVisits = [];
    var pVisits = [];
    var cVisits = [];
    if (visited != null) {
      tVisits = visited.filter(function(val) {return val.entity === "tournament";});
      //console.log("tournament visits detected: " + JSON.stringify(tVisits));
      if (tVisits.length > 3) {
        tVisits = this.getTopXVisits(tVisits, 3);
      }
      this.tournamentVisits = tVisits;

      pVisits = visited.filter(function(val) {return val.entity === "person";});
      if (pVisits.length > 3) {
        pVisits = this.getTopXVisits(pVisits, 3);
      }
      this.personVisits = pVisits;

      cVisits = visited.filter(function(val) {return val.entity === "club";});
      if (cVisits.length > 3) {
        cVisits = this.getTopXVisits(cVisits, 3);
      }
      this.clubVisits = cVisits;
    }
  },
  methods: {
    getTopXVisits: function(visits, topX) {
      function compare(a, b) {
        if (a.count > b.count)
          return -1;
        if (a.count < b.count)
          return 1;
        return 0;
      }
      visits = visits.sort(compare);
      return visits.slice(0, topX);
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.linkContainer {
  max-width: 98vw;
  display: grid;
  grid-gap: 1vw;
}

.divLink {
  border: solid 1px;
  border-radius: 2px;
  text-align: center;
}

.floatLeft {
  float: left;
  margin-top:3px;
  margin-left:4px;
}

.link {
  text-decoration: none;
  padding-left: 4px;
}

.divLink:hover {
  border: 1px solid white;
  color: white;
  transition: border .3s linear, color .3s linear, background-color .3s linear;
}

/* mobile */
@media screen and (max-width: 600px) {
.linkContainer {
  padding: 1vw;
  width: 98vw;
  grid-template-columns: repeat(2, 1fr);
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
.linkContainer {
  padding: 1vw;
  width: 70vw;
  grid-template-columns: repeat(3, 1fr);
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
.linkContainer {
    padding: 1vw;
    width: 50vw;
    grid-template-columns: repeat(3, 1fr);
  }
}

</style>
